"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextInputForForm = TextInputForForm;
var _react = _interopRequireWildcard(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _PopoverAndOverlay = require("./PopoverAndOverlay");
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function TextInputForForm(_ref) {
  var {
    fieldName,
    label,
    errors,
    touched,
    values,
    onChange,
    onBlur,
    type,
    inputMode,
    maxLength,
    placeholder,
    prepend,
    append,
    popoverText,
    htmlSize,
    id,
    disabled,
    ariaLabel,
    helperText
  } = _ref;
  // Expects fieldName, label, errors, values, onChange, onBlur, type, inputMode, maxLength, placeholder, prepend, append, htmlSize
  var optionalAttributes = {};
  ariaLabel ? optionalAttributes['aria-label'] = ariaLabel : '';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, label ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: id
  }, label, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, " "), popoverText && /*#__PURE__*/_react.default.createElement(_PopoverAndOverlay.PopoverAndOverlay, {
    fieldName: fieldName,
    text: (0, _htmlReactParser.default)(popoverText)
  })) : '', /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "".concat(errors[fieldName] && touched[fieldName] && 'is-invalid'),
    disabled: disabled
  }, prepend && /*#__PURE__*/_react.default.createElement(PrependInput, {
    symbol: "$"
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, _extends({
    id: id ? id : fieldName,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    name: fieldName,
    value: values[fieldName],
    placeholder: placeholder,
    onChange: onChange,
    onBlur: onBlur,
    htmlSize: htmlSize,
    disabled: disabled
  }, optionalAttributes)), append && /*#__PURE__*/_react.default.createElement(AppendInput, {
    symbol: "%"
  })), errors[fieldName] && (touched[fieldName] || values[fieldName]) ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl.Feedback, {
    type: "invalid",
    className: "custom-feedback"
  }, errors[fieldName]) : /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl.Feedback, {
    type: "helper",
    className: "form-text"
  }, helperText)));
}
function PrependInput(_ref2) {
  var {
    symbol
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "input-group-prepend"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "input-group-text"
  }, symbol));
}
function AppendInput(_ref3) {
  var {
    symbol
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "input-group-append"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "input-group-text"
  }, symbol));
}